import { render, staticRenderFns } from "./LeilaoParceiroCard.vue?vue&type=template&id=137a0e30&scoped=true"
import script from "./LeilaoParceiroCard.vue?vue&type=script&lang=js"
export * from "./LeilaoParceiroCard.vue?vue&type=script&lang=js"
import style0 from "./LeilaoParceiroCard.vue?vue&type=style&index=0&id=137a0e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a0e30",
  null
  
)

export default component.exports